import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListLargeIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: StoryListLargeIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
